import { Trans } from '@lingui/react/macro';

import { Link } from '@/components/typography';

const TermsOfUseLink = () => {
  return (
    <Link
      variant="caption1"
      color="aqua"
      to="https://www.channel99.com/terms-of-service"
      target="_blank"
    >
      <Trans>Terms of Use</Trans>
    </Link>
  );
};

export default TermsOfUseLink;
